import { Layout } from "antd";
import { Outlet } from "react-router-dom";
import CustomHeader2 from "./landingpage/Header/CustomHeader2";
import { Footers } from "./index";

const { Content } = Layout;

export const Main = () => {
  return (
    <Layout style={{ minHeight: "100vh", background: "#fff" }}>
      {/* Header */}
      <CustomHeader2 />

      {/* Content */}
      <Content
        style={{
          margin: 0,
          padding: 0,
          width: "100%",
          flex: 1,
          position: "relative",
          zIndex: 10,
        }}
      >
        <Outlet />
      </Content>

      {/* Footer */}
      <div style={{ zIndex: 10, position: "relative" }}>
        <Footers />
      </div>
    </Layout>
  );
};
